import { TOWER_MENU_ITEMS } from '@silverfort-nodelibs/common/utils/consts';
import { Icons } from '@silverfort/sf-components';

export const LAYOUT_PAGE_DATA = {
    [TOWER_MENU_ITEMS.DASHBOARD]: { title: 'Dashboard', icon: Icons.HomePage, hideBanner: true },
    [TOWER_MENU_ITEMS.INVENTORY]: { title: 'Identity Graph and Inventory', icon: Icons.User },
    [TOWER_MENU_ITEMS.PROTECTION_POLICIES]: {
        title: 'Policies',
        tabTitle: 'Protection - Policies',
        icon: Icons.UserGroupEdit
    },
    [TOWER_MENU_ITEMS.PROTECTION_USER_MANAGEMENT]: {
        title: 'MFA User Management',
        tabTitle: 'Protection - MFA User Management',
        icon: Icons.UserGroupCog
    },
    [TOWER_MENU_ITEMS.PA]: { title: 'Privileged Access Security', icon: Icons.DomainAdmin },
    [TOWER_MENU_ITEMS.NHI_AD]: {
        title: 'Service Accounts (Active Directory)',
        tabTitle: 'Non Human Identities - Active Directory',
        icon: Icons.ServiceAccountRobot
    },
    [TOWER_MENU_ITEMS.NHI_CLOUD]: {
        title: 'Non-Human Identities (Cloud)',
        tabTitle: 'Non Human Identities - Cloud',
        icon: Icons.ServiceAccountRobot,
        EA: true,
        hideBanner: true
    },
    [TOWER_MENU_ITEMS.ISPM_AD]: {
        title: 'Identity Security Posture Management (Active Directory)',
        tabTitle: 'ISPM - Active Directory',
        icon: Icons.IdentitySearch
    },
    [TOWER_MENU_ITEMS.ISPM_CLOUD]: {
        title: 'Identity Security Posture Management (Cloud)',
        tabTitle: 'ISPM - Cloud',
        icon: Icons.Target,
        hideBanner: true
    },
    [TOWER_MENU_ITEMS.ITDR_AD]: {
        title: 'Identity Threat Detection & Response (Active Directory)',
        icon: Icons.Target
    },
    [TOWER_MENU_ITEMS.ITDR_CLOUD]: {
        title: 'Identity Threat Detection & Response (Cloud)',
        icon: Icons.Target,
        hideBanner: true
    },
    [TOWER_MENU_ITEMS.ACCESS_ANALYSIS_AD]: {
        title: 'Access Intelligence (Active Directory)',
        icon: Icons.Key,
        EA: true
    },
    [TOWER_MENU_ITEMS.ACCESS_ANALYSIS_CLOUD]: {
        title: 'Access Intelligence (Cloud)',
        icon: Icons.Key,
        EA: true,
        hideBanner: true
    },
    [TOWER_MENU_ITEMS.APP_DISCOVERY]: { title: 'App Discovery', icon: Icons.AppWindow },
    [TOWER_MENU_ITEMS.LOGS]: { title: 'Authentication Logs', icon: Icons.Document },
    [TOWER_MENU_ITEMS.MONITOR_SYSTEM_STATUS]: {
        title: 'System Status',
        tabTitle: 'Monitor - System Status',
        icon: Icons.Monitor
    },
    [TOWER_MENU_ITEMS.MONITOR_SOFTWARE_UPDATES]: {
        title: 'Software Updates',
        tabTitle: 'Monitor - Software Updates',
        icon: Icons.Sync
    },
    [TOWER_MENU_ITEMS.MONITOR_NOTIFICATIONS]: {
        title: 'System Events',
        tabTitle: 'Monitor - System Events',
        icon: Icons.Monitor
    },
    [TOWER_MENU_ITEMS.SETTINGS]: { title: 'Settings', icon: Icons.SettingsPage, hideBanner: true },
    [TOWER_MENU_ITEMS.INCIDENT_INVESTIGATION]: { title: 'Incident Investigation', icon: Icons.Investigate },
    [TOWER_MENU_ITEMS.AI_AGENT_SECURITY_CLOUD]: {
        title: 'AI Agent Security',
        tabTitle: 'AI Agent Security',
        icon: Icons.Magic,
        hideBanner: true
    },
    [TOWER_MENU_ITEMS.AUTHENTICATION_FIREWALL_DASHBOARD]: {
        title: 'Authentication Firewall',
        tabTitle: 'Authentication Firewall',
        icon: Icons.Shield
    },
    [TOWER_MENU_ITEMS.UNIVERSAL_MFA_DASHBOARD]: {
        title: 'Universal MFA',
        tabTitle: 'Universal MFA',
        icon: Icons.ShieldInnerLock
    }
};
